/*
 * @Author: your name
 * @Date: 2020-11-16 11:18:12
 * @LastEditTime: 2021-09-24 12:07:17
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \鲁南项目\src\modules\personAR\api\index.js
 */
export const api = {
  person: {
    getRecordList: '/bas/turnstilegate/queryTurnstilegateTrafficRecordList.json', // 获取员工通行记录列表
    areaList: '/cms/account/queryAssociationalDeviceTreeApi.json', // 获取区域
  }
}